import Text from "@/components/Text";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Drawer, DrawerContent, DrawerFooter } from "@/components/ui/drawer";
import useDetectSizeDevice from "@/hooks/useDetectSizeDevice";
import { setActionTriggerNeedNetwork } from "@/store/restrictedFeatureState";
import { X } from "lucide-react";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

const RestrictedExplorerAction: FC = () => {
  const { sm } = useDetectSizeDevice();
  const { t } = useTranslation();

  if (!sm) {
    return (
      <Drawer
        open={true}
        onOpenChange={(open) => {
          if (!open) {
            setActionTriggerNeedNetwork(false);
          }
        }}
      >
        <DrawerContent>
          <div className="flex flex-col gap-[24px] p-[16px] overflow-y-auto">
            <div className="w-[100%] flex justify-end">
              <X
                className="cursor-pointer"
                onClick={() => {
                  setActionTriggerNeedNetwork(false);
                }}
              />
            </div>
            <img src="/img/pricing/query-limited.png" />
            <div className="flex flex-col gap-[8px]">
              <Text fontSize={20} fontWeight={600}>
                {t("restricted_explorer_title")}
              </Text>
              <div className="flex flex-col gap-[8px]">
                <Text fontSize={14} fontWeight={400}>
                  {t("restricted_explorer_subtitle")}
                </Text>
                <Text fontSize={14} fontWeight={400}>
                  {t("restricted_explorer_subtitle_1")}
                </Text>
                <Text fontSize={14} fontWeight={400}>
                  {t("restricted_explorer_subtitle_2")}
                </Text>
              </div>
            </div>
            <DrawerFooter className="flex flex-col gap-[12px]">
              <Button
                onClick={() => {
                  setActionTriggerNeedNetwork(false);
                }}
                className="w-[100%]"
                variant="secondaryFilled"
              >
                {t("close")}
              </Button>
              <a
                className="w-[100%]"
                target="_blank"
                rel="noopener noreferrer"
                href="https://calendly.com/demo-krunsh/30min?month=2026-03"
              >
                <Button
                  className="w-[100%]"
                  onClick={() => {
                    setActionTriggerNeedNetwork(false);
                  }}
                >
                  {t("contact_expert")}
                </Button>
              </a>
            </DrawerFooter>
          </div>
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog open={true}>
      <DialogContent showCloseButton={false}>
        <DialogDescription className="flex flex-col gap-[24px]">
          <div className="w-[100%] flex justify-end">
            <X
              className="cursor-pointer"
              onClick={() => {
                setActionTriggerNeedNetwork(false);
              }}
            />
          </div>
          <img src="/img/pricing/query-limited.png" />
          <div className="flex flex-col gap-[8px]">
            <Text fontSize={20} fontWeight={600}>
              {t("restricted_explorer_title")}
            </Text>
            <div className="flex flex-col">
              <Text fontSize={14} fontWeight={400}>
                {t("restricted_explorer_subtitle")}
              </Text>
              <Text fontSize={14} fontWeight={400}>
                {t("restricted_explorer_subtitle_1")}
              </Text>
              <Text fontSize={14} fontWeight={400}>
                {t("restricted_explorer_subtitle_2")}
              </Text>
            </div>
          </div>
        </DialogDescription>

        <DialogFooter className="grid grid-cols-2 gap-[16px] mt-[12px]">
          <Button
            onClick={() => {
              setActionTriggerNeedNetwork(false);
            }}
            className="w-[100%]"
            variant="secondaryFilled"
          >
            {t("close")}
          </Button>
          <a
            className="w-[100%]"
            target="_blank"
            rel="noopener noreferrer"
            href="https://calendly.com/demo-krunsh/30min?month=2026-03"
          >
            <Button
              className="w-[100%]"
              onClick={() => {
                setActionTriggerNeedNetwork(false);
              }}
            >
              {t("contact_expert")}
            </Button>
          </a>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RestrictedExplorerAction;
